import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ButtonWrapper, Label, CircleIcon } from './imgButton.styles';
import { getCommercialButton } from '~/utils/getCommercialButton';
const IconComponent = ({ Icon, width, height }) => (_jsx("div", { children: width && height ? _jsx(Icon, { width: width, height: height }) : _jsx(Icon, {}) }));
const ImgButton = ({ className, category, small, iconWidth, iconHeight, length = 0, displayRightBorder, ...rest }) => {
    const btnClass = classNames(className, {
        small,
    });
    const { icon, label } = getCommercialButton(category);
    return (_jsxs(ButtonWrapper, { length: length, className: btnClass, displayRightBorder: displayRightBorder, ...rest, children: [_jsx(CircleIcon, { children: _jsx(IconComponent, { Icon: icon, width: iconWidth, height: iconHeight }) }), _jsx(Label, { length: length, children: label })] }));
};
export default ImgButton;
